// extracted by mini-css-extract-plugin
export default {"overlay":"CookieBar_overlay__UmHO9","cookieBar":"CookieBar_cookieBar__J6j6E","text":"CookieBar_text__NfPvF","acceptButton":"CookieBar_acceptButton__bV06Q"};